import type { SVGProps } from "react"

export default function PauseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 12H0V0H4V12ZM10.667 12H6.66699V0H10.667V12Z"
        fill="currentColor"
      />
    </svg>
  )
}
